import { IcoCheck24 } from '@onefootprint/icons';

import Text from '../../../../../../text';
import type { BaseSelectOption } from '../../../../base-select.types';

export type ItemProps = {
  option: BaseSelectOption;
  value?: BaseSelectOption;
  onSelect: () => void;
};

const Item = ({ option, value, onSelect }: ItemProps) => {
  const { label } = option;
  const selected = option.value === value?.value;

  return (
    // biome-ignore lint/a11y/useSemanticElements: TODO: change to <option />
    <div
      role="option"
      onClick={onSelect}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
      tabIndex={0}
    >
      <div className="fp-dropdown-item flex flex-row justify-between py-3 px-4 cursor-pointer">
        <Text variant="body-2" className="text-(--dropdown-color-primary)">
          {label}
        </Text>
        <div>{selected ? <IcoCheck24 /> : null}</div>
      </div>
    </div>
  );
};

export default Item;
